import moment from 'moment'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  methods: {
    // Get the start date for a date range type
    calculateStartDateForDateRangeType(dateRangeType, customDate = null) {
      switch(dateRangeType) {
        case ChartDateRangeTypes.today:
          return moment().local().startOf('day')
        case ChartDateRangeTypes.allTime:
          return moment('2000-01-01').local().startOf('day')
        case ChartDateRangeTypes.custom:
          if(customDate)
            return moment(customDate).local().startOf('day')
          return moment().local().startOf('day')

        // Default - Today
        default:
          return moment().local().startOf('day')
      }
    },
    // Get the end date for a date range type
    calculateEndDateForDateRangeType(dateRangeType, customDate = null) {
      switch(dateRangeType) {
        case ChartDateRangeTypes.today:
          return moment().local().endOf('day')
        case ChartDateRangeTypes.allTime:
          return moment().local().endOf('day')
        case ChartDateRangeTypes.custom:
          if(customDate)
            return moment(customDate).local().endOf('day')
          return moment().local().endOf('day')

        // Default - Today
        default:
          return moment().local().endOf('day')
      }
    }
  }
}